<template>
    <div class="settings-main-statuses">
        <h4 class="settings-main-statuses__title">
            <span>{{ $t('settings.miningStatuses') }}</span>
            <div class="settings-main-statuses__checkbox">
                <span>{{ $t('settings.mail') }}</span>
                <span style="margin-left: 10px;  margin-right: 5px;">{{ $t('settings.tg') }}</span>
            </div>
        </h4>

        <div class="settings-main-statuses__checkboxes">
            <div class="settings-main-statuses__checkbox">
                <p class="settings-main-statuses__checkbox-label">
                    {{ $t('workers.connectingWorker') }}
                </p>

                <div class="settings-main-statuses__checkbox" >
                    <UICheckbox
                        :value="form.connectingWorker.email"
                        :small="true"
                        :disabled="true"
                        @changed="onChangeCheckbox(['connectingWorker', 'email'], $event);"
                    />
                    <span style="margin-left: 5px;" >
                        <UICheckbox
                            :value="form.connectingWorker.telegram"
                            :small="true"
                            :disabled="getDisabled"
                            @changed="onChangeCheckbox(['connectingWorker', 'telegram'], $event);"
                        />
                    </span>
                </div>
            </div>

            <div class="settings-main-statuses__checkbox">
                <p class="settings-main-statuses__checkbox-label">
                    {{ $t('settings.dropHashrate') }}
                </p>

                <div class="settings-main-statuses__checkbox">
                    <UICheckbox
                        :value="form.dropHashrate.email"
                        :small="true"
                        :disabled="true"
                        @changed="onChangeCheckbox(['dropHashrate', 'email'], $event);"
                    />
                    <span style="margin-left: 5px;" >
                        <UICheckbox
                            :value="form.dropHashrate.telegram"
                            :small="true"
                            :disabled="getDisabled"
                            @changed="onChangeCheckbox(['dropHashrate', 'telegram'], $event);"
                        />
                    </span>
                </div>
            </div>

            <div class="settings-main-statuses__checkbox">
                <p class="settings-main-statuses__checkbox-label">
                    {{ $t('settings.onlineOfflineWorker') }}
                </p>

                <div class="settings-main-statuses__checkbox">
                    <UICheckbox
                        :value="form.onlineOfflineWorker.email"
                        :small="true"
                        :disabled="true"
                        @changed="onChangeCheckbox(['onlineOfflineWorker', 'email'], $event);"
                    />
                    <span style="margin-left: 5px;" >
                        <UICheckbox
                            :value="form.onlineOfflineWorker.telegram"
                            :small="true"
                            :disabled="getDisabled"
                            @changed="onChangeCheckbox(['onlineOfflineWorker', 'telegram'], $event);"
                        />
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UICheckbox from "@/components/ui/checkbox/checkbox.vue";

import {CHECKBOXES} from "@/components/shared/settings/main/notifications.vue";

export default {
    name: "SettingsMainStatuses",
    components: {
        UICheckbox,
    },
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
        telegram: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        getDisabled() {
            return this.loading;
        },

        getCheckboxes() {
            return CHECKBOXES;
        },
    },
    methods: {
        onChangeCheckbox(key, value) {
            this.$emit("checkbox", {key, value});
        },
    },
};
</script>

<style lang="scss">
.settings-main-statuses {
    .settings-main-statuses__title {
        font-size: 14px;
        line-height: 17px;
        color: $txt-main;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 6px;
    }

    .settings-main-statuses__checkboxes {
        display: flex;
        flex-direction: column;
        grid-row-gap: 6px;
    }

    .settings-main-statuses__checkbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 16px;
    }

    .settings-main-statuses__checkbox-label {
        font-size: 14px;
        line-height: 17px;
        color: $txt-main;
    }
}
</style>
